module.exports = __webpack_public_path__ + "static/media/andrew-on-fire.620bb020.jpg";